import { render } from "./SettingGettingValues.vue?vue&type=template&id=1d56944d&scoped=true&ts=true"
import script from "./SettingGettingValues.vue?vue&type=script&lang=ts"
export * from "./SettingGettingValues.vue?vue&type=script&lang=ts"

import "./SettingGettingValues.vue?vue&type=style&index=0&id=1d56944d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d56944d"]])

export default __exports__